// extracted by mini-css-extract-plugin
export var fontsLoading = "form-module--fonts-loading--JOxmG";
export var form = "form-module--form--kRRqr";
export var formWrapper = "form-module--formWrapper--8BgUC";
export var title = "form-module--title--7eegA";